import PlanThumbnail, { DEFAULT_ELEVATION_URL } from "lib/components/builders/PlanThumbnail";
import type { ReactNode } from "react";
import React from "react";
import type { LinkProps } from "ui/components/Link";
import Link from "ui/components/Link";
import cx from "ui/cx";
import styles from "./PlanCard.module.scss";

export function PlanCards({
  children,
  horizontalScroll,
  className,
}: {
  children: ReactNode;
  horizontalScroll?: boolean;
  className?: string;
}) {
  const classNames = cx(styles.planCards, horizontalScroll && styles.horizontalScroll, className);
  return <div className={classNames}>{children}</div>;
}
export interface PlanCardProps extends Pick<LinkProps, "href"> {
  onSelect?: (e?: React.MouseEvent<HTMLDivElement>) => void;
  imgUrl: string;
  selectable?: boolean;
  selected?: boolean;
  children: ReactNode;
  imageWidth?: number;
  imageHeight?: number;
}

export default function PlanCard({
  onSelect,
  href,
  selected,
  imgUrl,
  children,
  selectable,
  imageWidth,
  imageHeight,
}: PlanCardProps) {
  const fallback = !imgUrl || imgUrl === DEFAULT_ELEVATION_URL;
  const classNames = cx({ styles, planCard: true, selected, selectable, fallback });

  return (
    <div className={classNames} onClick={selectable ? onSelect : undefined} data-testid="plan-card">
      <Link href={href} disabled={!selectable} className={styles.cardLink} data-testid="plan-card-link" />
      <div className="community-plan-card-image">
        <PlanThumbnail
          imgUrl={imgUrl}
          backgroundSize="contain"
          backgroundImageWidth={imageWidth}
          backgroundImageHeight={imageHeight}
        />
      </div>
      <div className="community-plan-card-content">{children}</div>
    </div>
  );
}
